(function(){

    /*
    * Inizializzazione Swiper.js
    * */
    var swiper = new Swiper(".newsSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });

    var swiper = new Swiper(".awardsSwiper", {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 50,
            },
            "992": {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 80,
            },
            "1200": {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 80,
            },
        },
    });

})();
